import { render, staticRenderFns } from "./SinglePostPage.vue?vue&type=template&id=bf5ae998&scoped=true&"
import script from "./SinglePostPage.vue?vue&type=script&lang=ts&"
export * from "./SinglePostPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5ae998",
  null
  
)

export default component.exports